import { useContext } from 'react';
import { actions, Context } from '~/components/store';
function useStore() {
    const [state, dispatch, storage] = useContext(Context);

    return { state: state, dispatch: dispatch, actions: actions, storage: storage };
}
export default useStore;
